<template>
  <div class="miniFullCalendar">
    <FullCalendar
      ref="miniFullCalendar"
      default-view="dayGridMonth"
      :header="header"
      :plugins="calendarPlugins"
      :events="calendarEvents"
      :content-height="230"
      :first-day="1"
      :display-event-time="false"
      :column-header-text="columnHeaderText"
      :title-format="titleFormat"
    />
  </div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';

export default {
  components: {
    FullCalendar,
  },

  props: {
    singleAvailabilityPeriod: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      header: {
        left: 'title',
        center: '',
        right: '',
      },
      calendarPlugins: [
        dayGridPlugin,
        interactionPlugin,
      ],
      titleFormat: { month: 'long' },
    };
  },

  computed: {
    calendarEvents() {
      if (!this.singleAvailabilityPeriod) return [];
      if (!this.$refs.miniFullCalendar) return [];

      this.$refs.miniFullCalendar.getApi().gotoDate(this.singleAvailabilityPeriod.end);
      return [
        {
          start: this.singleAvailabilityPeriod.start,
          end: this.singleAvailabilityPeriod.end,
          backgroundColor: '#4387ff',
        },
      ];
    },
  },

  methods: {
    columnHeaderText(date) {
      let value;
      switch (date.getDay()) {
        case 0:
        case 6:
          value = 'S';
          break;
        case 1:
          value = 'M';
          break;
        case 2:
        case 4:
          value = 'T';
          break;
        case 3:
          value = 'W';
          break;
        case 5:
          value = 'F';
          break;
        default:
          value = '-';
      }

      return value;
    },
  },
};
</script>

<style lang='scss'>
@import '~@fullcalendar/core/main.css';
@import '~@fullcalendar/daygrid/main.css';

.miniFullCalendar {
  background: rgba(255, 255, 255, 0.15);
  padding: 5px;
  padding-top: 15px;
  border-radius: 5px;

  .fc {
    th,
    td {
      border-width: 0;
    }

    .fc-header-toolbar {
      padding: 0 4%;
      margin-bottom: 15px;

      .fc-left h2 {
        font-weight: normal;
        font-size: 16px;
      }

      .fc-right {
        .fc-button-group {
          .fc-button {
            background-color: transparent;
            border-color: transparent;
            box-shadow: none;
            padding: 0;
          }
        }
      }
    }

    .fc-view-container {
      .fc-event-container {
        position: relative;
        top: -26px;
        z-index: -1;

        .fc-event {
          cursor: pointer;
          border-radius: 10px;
        }
      }

      .fc-row.fc-week {
        height: 30px !important;
        min-height: 30px;
      }

      .fc-day-number {
        width: 100%;
        text-align: center;
        box-sizing: border-box;
      }

      .fc-day-grid-event {
        margin: 3px 0 !important;
      }

      .fc-day-grid-container {
        height: 100% !important;
      }
    }

    &.fc-ltr .fc-dayGrid-view .fc-day-top .fc-day-number {
      float: left;
    }
  }

  .fc-today {
    background: transparent !important;
    border: none !important;
  }
}

</style>
